import { render, staticRenderFns } from "./GoalsLearnMore.vue?vue&type=template&id=85bd354c&"
import script from "./GoalsLearnMore.vue?vue&type=script&lang=ts&"
export * from "./GoalsLearnMore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports